import * as React from 'react';
import AnchorLinks from './AnchorLinks';
import OneColumnWysiwyg from './OneColumnWysiwyg';
import ImageAndCaption from './ImageAndCaption';
import YouTubePlayer from './YouTubePlayer';
import IconTip from './IconTip';
import HeroIntro from './HeroIntro';
import ImageAndContentRL from './ImageAndContentRL';
import CtaFullWidthImage from './CtaFullWidthImage';
import CtaInlineImage from './CtaInlineImage';
import InlineGraphic from './InlineGraphic';
import InlineCtaTile from './InlineCtaTile';
import RelevantTools from './RelevantTools';
import DocumentsAndResources from './DocumentsAndResources';
import Testimonial from './Testimonial';
import CallToAction from './CallToAction-NEW';
import PressTable from './PressTable';
import ContactUs from './ContactUs';
import CategoryHeroBanner from './CategoryHeroBanner';
import OutageChecker from './OutageChecker';
import FormModule from './FormModule';
import Accordion from './Accordion';
import SurveyMonkey from './SurveyMonkey';
import ArticleIntro from './ArticleIntro';
import FAQs from './FAQs';
import { replaceUrls } from '../helpers/common';
import IconCardsRow from './IconCardsRow';
import RelatedContentSlider from './RelatedContentSlider';
import SubcategoryHeroBanner from './SubcategoryHeroBanner';
import AudioPlayerModule from './AudioPlayerModule';

export default function PageModules({ modules, childPages, breadcrumbs }) {
  if (!modules) {
    return null;
  }

  return modules.map((module, i) => {
    switch (module.__typename) {
      // new and updated components below here
      case 'WpPage_Contentbuilder_Modules_PageAnchorLinks':
        return (
          <AnchorLinks
            key={i}
            module={module} // The data for this block
            modules={modules} // All blocks
          />
        );
      case 'WpPage_Contentbuilder_Modules_Content':
        return (
          <OneColumnWysiwyg
            key={i}
            heading={module.heading}
            textColor={module.textColor}
            text={replaceUrls(module.content)}
            anchorTagLinkText={module.anchorTagLinkText}
            fullWidth={module.fullWidth}
          />
        );
      case 'WpPage_Contentbuilder_Modules_ArticleIntro':
        return (
          <ArticleIntro
            key={i}
            text={module.text}
            date={module.date}
            anchorTagLinkText={module.anchorTagLinkText}
          />
        );
      case 'WpPage_Contentbuilder_Modules_Video':
        return <YouTubePlayer key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_ImageWithCaption':
        return (
          module.image && (
            <ImageAndCaption
              key={i}
              image={module.image}
              caption={module.caption}
              anchorTagLinkText={module.anchorTagLinkText}
              module={module}
            />
          )
        );
      case 'WpPage_Contentbuilder_Modules_ImageAndContentLr':
        return <ImageAndContentRL key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_FormModule':
        return <FormModule key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_HeroIntro':
        return (
          <HeroIntro
            key={i}
            image={module.image}
            liney_lesson_content={module.lineyLessonContent}
            heading={module.heading}
            emphasised_message={module.emphasisedMessage}
            intro={module.intro}
            anchorTagLinkText={module.anchorTagLinkText}
          />
        );
      case 'WpPage_Contentbuilder_Modules_OutageChecker':
        return <OutageChecker key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_CtaFullWidthImage':
        return <CtaFullWidthImage key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_CategoryHeroBanner':
        return <CategoryHeroBanner key={i} module={module} childPages={childPages} breadcrumbs={breadcrumbs} />;
      case 'WpPage_Contentbuilder_Modules_CtaInlineImage':
        return <CtaInlineImage key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_InlineGraphic':
        return <InlineGraphic key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_RelevantTools':
        return <RelevantTools key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_InlineCtaTile':
        return <InlineCtaTile key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_Accordions':
        return <Accordion key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_Faqs':
        return <FAQs key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_Documents': {
        return <DocumentsAndResources key={i} module={module} title={module?.heading} documentLimit={8} />;
      }
      case 'WpPage_Contentbuilder_Modules_ContactUs':
        return <ContactUs key={i} anchorTagLinkText={module.anchorTagLinkText} />;
      case 'WpPage_Contentbuilder_Modules_TestimonialBlock':
        return <Testimonial key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_CallToAction':
        return <CallToAction key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_PressTable':
        return <PressTable key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_AudioPlayer':
        return <AudioPlayerModule key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_SurveyMonkey':
        return <SurveyMonkey key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_SubcategoryHeroBanner':
        return <SubcategoryHeroBanner key={i} module={module} childPages={childPages} breadcrumbs={breadcrumbs} />;
      case 'WpPage_Contentbuilder_Modules_IconTip':
        return <IconTip key={i} module={module} />;
      case 'WpPage_Contentbuilder_Modules_FeatureWysiwyg':
        return (
          <OneColumnWysiwyg
            key={i}
            className="feature"
            feature={true}
            heading={module.heading}
            textColor={module.textColor}
            text={replaceUrls(module.content)}
            anchorTagLinkText={module.anchorTagLinkText}
          />
        );
      case 'WpPage_Contentbuilder_Modules_IconCardsRow':
        return <IconCardsRow key={i} heading={module.heading} ctaButton={module.ctaButton} cards={module.cards} theme={module.theme} />;
      case 'WpPage_Contentbuilder_Modules_RelatedContentSlider':
        return <RelatedContentSlider key={i} heading={module.heading} anchorTagLinkText={module.anchorTagLinkText} tiles={module.tiles} />;
    }
  });
}
